// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9

import ReactDOM from 'react-dom';
import { get, set } from 'lodash';

export const setRef = (Component, key) => nodeOrComponent => {
  // The ref might be a real DOM node _or_ a representation of a component
  set(Component, ['dangerousRefs', key], nodeOrComponent);
};

export const getRef = (Component, key) =>
  // Regardless of whether the ref is a real DOM node or a component,
  // always return the representative DOM node.
  ReactDOM.findDOMNode(get(Component, ['dangerousRefs', key]));
